module.exports = __webpack_public_path__ + "img/avatar2.e4ef8ad5.png";